import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';

import { computed, observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';

class MechaWeaponStore {
  @observable isActive = false;
  // 机甲详情信息
  @observable currentMechaMsg;

  // swiper初始化状态
  @observable initSwiperState = false;
  // 是否播放当前视频
  @observable isPlayingCurrentVideo = false;
  // 武器轮播图
  weaponSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: false,
      spaceBetween: 0,
      effect: 'fade',
      autoplay: false,
      allowTouchMove: false
    }
  });
  // 机甲主store
  @observable mechaStore;
  // 机甲武装视频播放状态
  @observable weaponVideoPlayState = false;

  constructor(options = {}) {
    Object.assign(this, options);
  }

  @computed
  get currentMechaMsgId() {
    return this.mechaStore.currentMechaMsg?.mecha_number;
  }


  // @computed
  get weaponMsg() {
    return this.mechaStore?.currentMechaMsg?.weapon;
  }

  @computed
  get weaponMsgList() {
    if (this.mechaStore && this.mechaStore?.currentMechaMsg?.weapon) {
      return this.mechaStore.currentMechaMsg.weapon;
    }
    return []; // 返回空数组，防止访问 undefined
  }

  @computed
  get currentWeaponObj() {
    return this.mechaStore?.currentMechaMsg?.weapon;
  }

  @computed
  get currentWeaponId() {
    return this.weaponSwiper.activeIndex;
  }

  /**
   * 点击切换武器swiper
   * @param index
   */
  onChangeWeaponSwiper = index => {
    this.isPlayingCurrentVideo = false;

    this.weaponSwiper.onChange(index);
  };

  use() {
    useMount(() => {});

    useEffect(
      () => {
        if (this.isActive) {
          clearTimeout(this.initTabAnimationStateTimer);
          this.initTabAnimationStateTimer = setTimeout(() => {
            this.initSwiperState = this.isActive;
          }, 1000);
        } else {
          this.initSwiperState = this.isActive;
          this.weaponSwiper.onChange(0);
        }
      },
      [this.isActive]
    );
  }
}

export default MechaWeaponStore;
